<template>
  <div class="app-container">
    <el-card shadow="never" class="sticky-container">
      <el-tabs v-model="activeKey">
        <el-tab-pane v-for="(item, index) in tabPanes" :key="index" :label="item.title" :name="item.name">
          <mall-config v-if="index === 0" />
          <wechat-config v-if="index === 1" />
          <payment-config v-if="index === 2" />
          <profit-config v-if="index === 3" />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import MallConfig from './components/mall-config'
import WechatConfig from './components/wechat-config'
import ProfitConfig from './components/profit-config'
import PaymentConfig from './components/payment-config'

export default {
  name: 'SystemIndex',
  components: { MallConfig, WechatConfig, ProfitConfig, PaymentConfig },
  data() {
    return {
      activeKey: 'mall',
      activePane: {},
      tabPanes: [{
        name: 'mall',
        title: '商城配置'
      }, {
        name: 'wechat',
        title: '微信小程序配置'
      }, {
        name: 'payment',
        title: '支付配置'
      }, {
        name: 'profit',
        title: '利润配置'
      }]
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep {
    .el-tabs__content {
      padding-top: 15px;
      padding-bottom: 0;
    }
  }
</style>
